import SpinnerChase from './SpinnerChase';

type TPreloaderProps = {
  className?: string;
}

const Preloader = ({ className }: TPreloaderProps) => {

  return <div id="preloader" className={className}>
    <div id="status">
      <SpinnerChase />
    </div>
  </div>;
}

export default Preloader;